import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { TipoReuniao } from '../../../core/tipo-reuniao';
import { TiposReuniaoService } from '../../../services/tipos-reuniao/tipo-reuniao.service';
import { ToastService } from '../../../services/toast/toast.service';
import { CarregarPerfil } from './../../../core/carregar-perfil';

@Component({
  selector: 'cadastrar-tipo-reuniao',
  templateUrl: './cadastrar-tipo-reuniao.component.html',
  styleUrls: ['./cadastrar-tipo-reuniao.component.css']
})
export class CadastrarTipoReuniaoComponent implements OnInit {

  tipoReuniao: TipoReuniao = new TipoReuniao();

  isAtualizar: boolean = false;


  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();

  mostrarBotaoCadastrar = true
  mostrarBotaoAtualizar = true;


  constructor(
    private tipoReuniaoService: TiposReuniaoService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastService: ToastService
  ) {
  }


  ngOnInit() {

    this.inicializarObjetos();

    
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

    if (!this.perfilAcesso.insere) {
      this.mostrarBotaoCadastrar = false;
    }

    if (!this.perfilAcesso.altera) {
      this.mostrarBotaoAtualizar = false;
    }

    let idTipoReuniao: number;
    idTipoReuniao = this.activatedRoute.snapshot.queryParams.id ? this.activatedRoute.snapshot.queryParams.id : null;
    if (idTipoReuniao) {
      this.isAtualizar = true;
      this.tipoReuniaoService.getById(idTipoReuniao).subscribe((tipoReuniao: TipoReuniao) => {
        this.tipoReuniao = tipoReuniao
      });
    }

  }
  inicializarObjetos() {
    this.tipoReuniao = new TipoReuniao();
  }

  mostrarBotaoLimpar() {
    if (this.isAtualizar) return false;
    if (!this.mostrarBotaoAtualizar) return false;
    if (!this.mostrarBotaoCadastrar) return false;

    return true;
  }

  cadastrar() {
    this.tipoReuniaoService.cadastrar(this.tipoReuniao).subscribe(() => {
      this.router.navigate(['tiposreunioes']);
      this.toastService.showSucesso("Tipo de reunião cadastrado com sucesso");
    });
  }

  limpar() {
    this.inicializarObjetos();
  }

  cancelar() {
    this.router.navigate(['tiposreunioes']);
  }


  atualizar() {
    this.tipoReuniaoService.alterar(this.tipoReuniao).subscribe(() => {
      console.log('t = ', this.tipoReuniao);
      this.router.navigate(['tiposreunioes']);
      this.toastService.showSucesso("Tipo de reunião atualizado com sucesso");
    });

  }

}
